module.exports = __webpack_public_path__ + "assets/img/1d72-it.svg";